export default __webpack_public_path__ + "dist/media/ProjectListingBg.0409a42c.svg";